import React from 'react'

export default function ForgotPassward() {
  return (
    <div>ForgotPassward</div>
  )
}
